const PATTERNS = {
  light: [10],
  medium: [20],
  success: [10, 50, 10],
  nav: [8],
  error: [30, 30, 30],
};

const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator;

export const haptic = (pattern = 'light') => {
  if (!canVibrate) return;
  try {
    navigator.vibrate(PATTERNS[pattern] || PATTERNS.light);
  } catch {}
};

export const useHaptic = () => haptic;
